var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSun(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 187,
    viewBox: "0 0 178 187",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.5 130.131C133.511 130.131 170 142.849 170 158.538C170 174.227 133.511 186.945 88.5 186.945C43.4888 186.945 7 174.227 7 158.538C7 142.849 43.4888 130.131 88.5 130.131ZM88.5 176.188C116.466 176.188 139.137 168.286 139.137 158.538C139.137 148.79 116.466 140.888 88.5 140.888C60.5338 140.888 37.8627 148.79 37.8627 158.538C37.8627 168.286 60.5338 176.188 88.5 176.188Z",
    fill: "url(#paint0_linear_5131_565381)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9987 88.9999L19.6289 48.9495L88.9966 8.8999L158.366 48.9506L88.9987 88.9999Z",
    fill: "#FFF7E0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55.2368 69.5078L53.3906 68.442L122.758 28.3923L124.604 29.4578L55.2368 69.5078Z",
    fill: "#F5B500"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.1862 72.3662L48.4375 65.583L117.805 25.5337L129.554 32.3169L60.1862 72.3662Z",
    fill: "#FFF7DF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9991 169.1L19.6289 129.049V48.9502L88.9991 89.0005V169.1Z",
    fill: "#FFEEBD"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.8,
    d: "M60.1908 72.3745V80.7961L58.7052 81.5768L57.2424 79.094L55.7572 79.8747L54.294 77.3916L52.8305 78.1852L51.3677 75.7024L49.9046 76.4959L48.4414 74.0125V65.5913L60.1908 72.3745Z",
    fill: "#FFF7DF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M158.369 129.049L89 169.1V89.0005L158.369 48.9502V129.049Z",
    fill: "#FFD04A"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.913 69.0844L135.717 79.0129C134.919 79.4739 134.27 79.0987 134.27 78.177V69.6704C134.27 68.749 134.919 67.6241 135.717 67.1634L152.913 57.2353C153.712 56.7743 154.361 57.1495 154.361 58.0704V66.5774C154.361 67.4988 153.712 68.6237 152.913 69.0844ZM135.717 67.9961C135.317 68.2275 134.991 68.7914 134.991 69.2538V77.7605C134.991 78.2233 135.317 78.4112 135.717 78.1795L152.914 68.2513C153.314 68.0203 153.64 67.456 153.64 66.9939V58.487C153.64 58.0245 153.314 57.8366 152.914 58.068L135.717 67.9961Z",
    fill: "#F5B500"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M137.043 76.3464L136.133 76.8719V68.8238L137.043 68.2983V76.3464Z",
    fill: "#F5B500"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M148.195 69.9076L147.285 70.4323V62.3846L148.195 61.8591V69.9076Z",
    fill: "#F5B500"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.814 75.3251L137.5 76.0841V68.036L138.814 67.2766V75.3251Z",
    fill: "#F5B500"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M146.881 70.667L145.566 71.426V63.3779L146.881 62.6189V70.667Z",
    fill: "#F5B500"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M151.394 68.0617L150.484 68.5871V60.5394L151.394 60.0139V68.0617Z",
    fill: "#F5B500"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M150.076 68.8217L148.762 69.581V61.5326L150.076 60.7739V68.8217Z",
    fill: "#F5B500"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M143.921 72.3763L141.949 73.5152V65.4671L143.921 64.3286V72.3763Z",
    fill: "#F5B500"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M140.076 74.5951L139.418 74.975V66.9265L140.076 66.5474V74.5951Z",
    fill: "#F5B500"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M152.497 67.4241L151.84 67.8036V59.7558L152.497 59.376V67.4241Z",
    fill: "#F5B500"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M141.341 73.8656L140.684 74.2451V66.1966L141.341 65.8171V73.8656Z",
    fill: "#F5B500"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M145.142 71.6712L144.484 72.0504V64.0027L145.142 63.6228V71.6712Z",
    fill: "#F5B500"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M99.5265 153.736C99.4984 153.425 99.2559 153.309 98.9647 153.477C98.7857 153.58 98.6262 153.769 98.5226 153.978C98.4603 154.104 98.3392 154.174 98.2769 154.12C98.1737 154.03 98.0142 154.025 97.8355 154.129C97.6564 154.232 97.4969 154.421 97.3934 154.63C97.3311 154.756 97.21 154.826 97.1484 154.772C97.0448 154.681 96.8857 154.678 96.7066 154.781C96.5276 154.884 96.3681 155.072 96.2648 155.282C96.2022 155.408 96.0815 155.478 96.0195 155.424C95.916 155.333 95.7568 155.33 95.5778 155.433C95.2862 155.601 95.0445 155.997 95.0156 156.34C95.0466 154.915 96.0445 153.208 97.2712 152.499C98.498 151.791 99.4959 152.346 99.5265 153.736Z",
    fill: "#F5B500"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M97.8334 157.995C97.3802 158.256 97.0117 158.044 97.0117 157.521V153.952L97.5272 153.654V157.223C97.5272 157.417 97.6646 157.497 97.8334 157.399C98.0018 157.302 98.1392 157.064 98.1392 156.869L98.655 156.572C98.655 157.095 98.2862 157.733 97.8334 157.995Z",
    fill: "#F5B500"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M99.7724 157.99L94.7684 160.879C94.2262 161.192 93.7852 160.938 93.7852 160.311V154.534C93.7852 153.907 94.2262 153.143 94.7684 152.83L99.7724 149.941C100.314 149.628 100.755 149.883 100.755 150.509V156.287C100.755 156.913 100.314 157.677 99.7724 157.99ZM94.7684 153.396C94.4961 153.553 94.275 153.936 94.275 154.25V160.028C94.275 160.342 94.4961 160.47 94.7684 160.313L99.7724 157.424C100.044 157.267 100.265 156.884 100.265 156.57V150.792C100.265 150.478 100.044 150.35 99.7724 150.507L94.7684 153.396Z",
    fill: "#F5B500"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M105.292 149.056C105.219 149.02 105.104 149.09 105.034 149.21L104.567 150.015L103.84 149.592C104.508 148.529 105.227 149.009 105.292 149.056Z",
    fill: "#F5B500"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M106.485 148.06L105.755 149.323L105.297 149.058C105.297 149.058 105.294 149.057 105.292 149.055C105.227 149.009 104.508 148.528 103.84 149.593L104.304 148.789C104.779 147.967 105.552 147.521 106.026 147.795L106.485 148.06Z",
    fill: "#F5B500"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M106.829 149.011L105.379 149.848L106.829 147.337V149.011Z",
    fill: "#F5B500"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M103.675 152.249C103.653 152.373 103.713 152.452 103.809 152.427L104.444 152.259L104.176 153.562C103.332 153.72 103.645 152.373 103.675 152.249Z",
    fill: "#F5B500"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M102.85 151.686L103.846 151.419L103.679 152.239C103.679 152.239 103.678 152.244 103.677 152.249C103.647 152.373 103.334 153.72 104.177 153.562L103.543 153.732C102.895 153.906 102.509 153.355 102.682 152.507L102.85 151.686Z",
    fill: "#F5B500"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M103.541 150.369L104.265 151.4L102.285 151.931L103.541 150.369Z",
    fill: "#F5B500"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M106.181 151.287C106.275 151.199 106.331 151.049 106.305 150.954L106.137 150.317L107.132 149.437C107.307 150.343 106.275 151.209 106.181 151.287Z",
    fill: "#F5B500"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M105.814 152.845L105.547 151.849L106.174 151.293C106.174 151.293 106.177 151.29 106.181 151.287C106.276 151.209 107.307 150.343 107.132 149.437L107.302 150.071C107.476 150.719 107.089 151.715 106.441 152.29L105.814 152.845Z",
    fill: "#F5B500"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M104.781 153.212L105.506 151.343L106.037 153.324L104.781 153.212Z",
    fill: "#F5B500"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M107.315 153.636L102.311 156.525C101.769 156.838 101.328 156.583 101.328 155.958V150.18C101.328 149.553 101.769 148.789 102.311 148.477L107.315 145.587C107.857 145.274 108.298 145.529 108.298 146.155V151.933C108.298 152.559 107.857 153.323 107.315 153.636ZM102.311 149.042C102.039 149.199 101.818 149.583 101.818 149.897V155.675C101.818 155.989 102.039 156.117 102.311 155.96L107.315 153.071C107.587 152.914 107.808 152.53 107.808 152.216V146.438C107.808 146.124 107.587 145.997 107.315 146.153L102.311 149.042Z",
    fill: "#F5B500"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M111.314 149.347L110.59 149.766V146.032L111.314 145.613V149.347Z",
    fill: "#F5B500"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M114.502 147.507V148.344L110 150.943V150.106L114.502 147.507Z",
    fill: "#F5B500"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M113.916 147.847L113.191 148.266V144.531L113.916 144.113V147.847Z",
    fill: "#F5B500"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M112.14 145.316L109.766 146.687L110.953 144.631L112.14 145.316Z",
    fill: "#F5B500"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M114.738 143.816L112.363 145.187L113.551 143.131L114.738 143.816Z",
    fill: "#F5B500"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M114.753 149.342L109.749 152.231C109.207 152.544 108.766 152.289 108.766 151.663V145.885C108.766 145.26 109.207 144.495 109.749 144.182L114.753 141.293C115.295 140.98 115.736 141.235 115.736 141.861V147.639C115.736 148.265 115.295 149.029 114.753 149.342ZM109.749 144.748C109.477 144.905 109.256 145.288 109.256 145.602V151.38C109.256 151.694 109.477 151.822 109.749 151.665L114.753 148.776C115.025 148.62 115.246 148.236 115.246 147.922V142.144C115.246 141.83 115.025 141.702 114.753 141.859L109.749 144.748Z",
    fill: "#F5B500"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M119.877 142.391C120.856 141.654 121.62 139.758 121.62 138.601L117.754 140.833C117.754 141.991 118.518 143.006 119.497 142.612V144.951L118.489 145.533V145.91L120.885 144.527V144.15L119.878 144.731V142.391H119.877Z",
    fill: "#F5B500"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M122.19 145.047L117.186 147.937C116.644 148.25 116.203 147.995 116.203 147.369V141.591C116.203 140.965 116.644 140.201 117.186 139.888L122.19 136.999C122.732 136.686 123.174 136.941 123.174 137.566V143.345C123.174 143.971 122.732 144.734 122.19 145.047ZM117.186 140.454C116.914 140.611 116.693 140.994 116.693 141.308V147.086C116.693 147.4 116.915 147.528 117.186 147.371L122.19 144.482C122.463 144.325 122.683 143.941 122.683 143.627V137.849C122.683 137.535 122.462 137.408 122.19 137.565L117.186 140.454Z",
    fill: "#F5B500"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.793 60.0139L89.6394 87.8919H88.3599L138.814 60.24L89.6397 90.1087L89 90.4975L88.3592 90.1087L38.793 60.0139Z",
    fill: "#FFD04A"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5131_565381)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.463 126.812L52.6552 125.538L49.3368 131.234L47.1445 132.508L50.463 126.812Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.8594 122.999L46.0516 121.725L52.655 125.538L50.4628 126.812L43.8594 122.999Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.4628 126.812L47.1444 132.508L43.8594 123L50.4628 126.812Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2599 97.0165L35.4522 95.7424L35.4307 103.33L33.2383 104.604L33.2599 97.0165Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6367 96.9979L28.8291 95.7239L35.4532 95.7425L33.2609 97.0166L26.6367 96.9979Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.2609 97.0167L33.2393 104.605L26.6367 96.998L33.2609 97.0167Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9805 110.48L37.1728 109.206L41.8247 117.263L39.6323 118.537L34.9805 110.48Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9816 110.48L39.6335 118.537L32.6055 117.188L34.9816 110.48Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3789 124.566L61.5711 123.292L63.9017 132.718L61.7093 133.992L59.3789 124.566Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.6992 127.234L56.8916 125.96L61.5739 123.292L59.3817 124.566L54.6992 127.234Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3817 124.566L61.7121 133.992L54.6992 127.235L59.3817 124.566Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6992 83.7445L34.8914 82.4705L41.9043 89.228L39.7119 90.5021L32.6992 83.7445Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6992 83.7446L39.7119 90.5022L35.0296 93.1706L32.6992 83.7446Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.0234 94.789L41.2159 93.5149C43.3172 92.2936 46.2279 92.4662 49.441 94.3212L47.2486 95.5953C44.0355 93.7403 41.1251 93.5676 39.0234 94.789Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2487 95.5952C53.6237 99.2758 58.7803 108.207 58.7596 115.544C58.7389 122.87 53.5484 125.828 47.1733 122.147C40.7884 118.461 35.6317 109.529 35.6524 102.203C35.6732 94.8667 40.8636 91.9087 47.2487 95.5952Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.5796 121.676L55.3872 122.95C57.4605 121.745 58.7469 119.184 58.7571 115.545C58.7778 108.208 53.621 99.2759 47.2461 95.5954L49.4385 94.3213C55.8134 98.002 60.9702 106.934 60.9495 114.27C60.939 117.909 59.653 120.471 57.5796 121.676Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.806 100.548L63.9984 99.2742L61.6221 105.982L59.4297 107.256L61.806 100.548Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.7773 99.1991L56.9698 97.925L63.998 99.2742L61.8056 100.548L54.7773 99.1991Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.8056 100.548L59.4293 107.257L54.7773 99.1992L61.8056 100.548Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2773 85.2345L49.4698 83.9604L52.745 93.4632L50.5526 94.7373L47.2773 85.2345Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.2774 85.2346L50.5527 94.7374L43.9492 90.9248L47.2774 85.2346Z",
    fill: "#F5B500"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1758 113.132L63.3681 111.858L69.9707 119.476L67.7786 120.75L61.1758 113.132Z",
    fill: "#D49D00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.1739 113.132L67.7766 120.75L61.1523 120.72L61.1739 113.132Z",
    fill: "#F5B500"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5131_565381",
    x1: 88.5,
    y1: 186.945,
    x2: 88.5,
    y2: 130.131,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.8
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5131_565381"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57.2462,
    height: 57.2462,
    fill: "white",
    transform: "translate(19.6797 79.6082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSun);
export default __webpack_public_path__ + "static/media/sun.2de6cdb0bf1291d29df5b67fe5eaf6f2.svg";
export { ForwardRef as ReactComponent };